export const WEBHOOK_EXCLUDE_METHOD_OPTIONS = {
  ALL: false,
  EXCLUDE_GET: true,
}
